import { Component, OnInit } from '@angular/core';
import { EmailCredentials } from '../app.types';
import { ModalController, IonContent, IonLabel, IonInput, IonButton } from '@ionic/angular/standalone';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-password-reset',
    templateUrl: './password-reset.page.html',
    styleUrls: ['./password-reset.page.scss'],
    standalone: true,
    imports: [IonButton, IonInput, IonLabel, IonContent, CommonModule, FormsModule]
})
export class PasswordResetPage implements OnInit {

  suec: EmailCredentials = {
    email: "",
    pass: "",
    rpass: ""
  }

  passwordPattern = new RegExp(/^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>-])[A-Za-z\d!@#$%^&*(),.?":{}|<>-]{8,}$/)
  
  constructor(
    public modalController: ModalController
  ) { }

  ngOnInit() {
  }

  isValidPassword() {
    const v = this.passwordPattern.test(this.suec.pass)
    return v
  }

  passwordsMatches() {
    if(this.suec.pass == "") return false
    return this.suec.pass == this.suec.rpass
  }

  resetPassword() {
    this.modalController.dismiss({password: this.suec.pass})
  }

}
